<div class="flex-container gap-6" style="height: 100%">
  <vl-widget-title
    [text]="'stats.repartition_articles_achetes' | trans"
    [widget]="widget()"
    [draggable]="false"
    [editable]="false"
    [filter]="true"
  >
    <ng-content class="drag-handler" select=".drag-handler"></ng-content>

    <ng-content class="filter" select=".filter">
      <div class="flex-row gap-4 align-center">
        @if (values().length) {
          <vl-chips state="active" size="small" iconRight="open_in_new" (action)="openFullList()">
            {{ 'button.see_all' | trans }}
          </vl-chips>
        }
        <vl-chips
          size="small"
          iconLeft="settings"
          (action)="trigger.attachOverlay()"
          [popoverTrigger]="filters"
          #trigger="popoverElement"
          [closeOnClickOutside]="true"
          state="enabled"
        >
          {{ 'button.filter' | trans }}
        </vl-chips>
      </div>
    </ng-content>
  </vl-widget-title>

  <ng-template #filters>
    <div class="flex-col w100 gap-8 justup-card p-8 up-3">

      <div class="flex" style="gap:.75rem; align-items:center; flex-wrap:wrap">
        <div class="caption-2 on-background-alt">
          Top {{ topCount() }} / {{ maxRows() }}
        </div>
        <input
          type="range"
          [min]="1"
          [max]="Math.max(1, maxRows())"
          [value]="topCount()"
          (input)="topCount.set(+($any($event.target).value || 1))"
          [disabled]="maxRows() <= 1"
          style="width:180px"
          aria-label="Limiter le nombre d’articles affichés"
        />
        <div class="search-wrap" style="display:flex;align-items:center;gap:.4rem;">
          <span class="caption-2 on-background-alt">Filtrer :</span>
          <input
            type="search"
            [value]="search()"
            (input)="search.set(($any($event.target).value||'').toString())"
            placeholder="Nom article…"
            class="ju-input"
            style="height:28px;padding:0 .5rem; min-width:200px"
            aria-label="Filtrer par nom d’article"
          />
        </div>
      </div>

      <vl-chips-toggle [(value)]="sortBy" [elements]="elementsSort"></vl-chips-toggle>
      <vl-chips-toggle [(value)]="viewMode" [elements]="elementsMode"></vl-chips-toggle>
      <vl-chips-toggle [(value)]="viewType" [elements]="elementsView"></vl-chips-toggle>
    </div>
  </ng-template>

  @if (metadata()?.loading) {
    <div class="h100 flex-row gap-16 widget-content">
      <div>
        <ngx-skeleton-loader
          count="1"
          appearance="circle"
          [theme]="{ 'height': '220px', 'width': '220px', 'background-color': 'var(--color-on-disabled)' }"
        ></ngx-skeleton-loader>
      </div>
      <div class="h100 w100 overflow-hidden">
        <ngx-skeleton-loader
          count="20"
          [theme]="{ 'background-color': 'var(--color-on-disabled)' }"
        ></ngx-skeleton-loader>
      </div>
    </div>
  } @else {
    @if (viewType() === 'PIE') {
      @if (values().length) {
        <div class="flex-row w100 widget-content fade-in">
          <div class="w40 overflow-hidden">
            <canvas #achatChart style="width:100%;display:block;"></canvas>
          </div>
          <div class="flex-col w60 overflow-scroll gap-4">
            @if (legendLabels()) {
              @for (label of legendLabels(); track label.label) {
                <div class="flex-row gap-8 p-8 border-on-disabled border-box border-8 align-center wrap">
                  <span
                    [style.background-color]="label.color"
                    class="w-16 h-16 border-full shrink-0"
                  ></span>
                  <span class="legend tiny on-background-alt">{{ label.label }}</span>
                  <span class="caption on-disabled">{{ label.percentage }}%</span>
                </div>
              }
            }
          </div>
        </div>
      } @else {
        <div class="widget-content empty">
          <div class="caption on-disabled">{{ 'filters.no_data' | trans }}</div>
        </div>
      }
    } @else {
      <div class="list-box w100" style="width:100%; overflow-x:auto;">
        <div class="thead caption-2 on-background-alt row-head" style="min-width:560px;">
          <div class="th th-client">Article</div>
          <div class="th th-value right">{{ viewMode() === 'CA' ? 'CA' : 'Unités' }}</div>
          <div class="th th-pct right">Part</div>
        </div>

        @for (r of listRows(); track r.key) {
          <div class="row table-row border-bottom-outline-opacity-50" style="min-width:560px;">
            <div class="td td-client" [title]="r.label">{{ r.label }}</div>
            <div class="td td-value right">{{ formatValue(r.value) }}</div>
            <div class="td td-pct right">
              <div class="pct">{{ r.pct.toFixed(1) }} %</div>
            </div>
          </div>
        }

        <div class="row row-total" style="min-width:560px;">
          <div class="td td-client strong">Total</div>
          <div class="td td-value right strong">{{ formatValue(totalTop()) }}</div>
          <div class="td td-pct right strong">{{ totalTopPct().toFixed(1) }} %</div>
        </div>
      </div>
    }
  }
</div>
